<template>
  <section id="contact" class="contact section">
    <div class="container section-title" data-aos="fade-up">
      <h2>Reclamation</h2>
      <p>Envoyez-nous vos réclamations ou suggestions de façon anonyme</p>
    </div>

    <div class="container" data-aos="fade" data-aos-delay="100">
      <div class="row gy-4">
        <div class="col-lg-4">
          <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
            <i class="bi bi-geo-alt flex-shrink-0"></i>
            <div>
              <h3>Localisation</h3>
              <p>Immeuble magasin Top Sport <br>
                Awlanléko, ilot 611-562<br>
                Maison Loukman SANI AGATHA</p>
            </div>
          </div>

          <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
            <i class="bi bi-telephone flex-shrink-0"></i>
            <div>
              <h3>Téléphone</h3>
              <p>+229 01 55 32 88 88
              </p>
            </div>
          </div>

          <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
            <i class="bi bi-envelope flex-shrink-0"></i>
            <div>
              <h3>Courrier</h3>
              <p>anagemcontact@gouv.bj</p>
            </div>
          </div>
        </div>

        <div class="col-lg-8">
          <Form @submit="submitReclamation" :validation-schema="reclamationSchema">
            <div class="row gy-4">
              <div class="col-md-6">
                <Field name="nom" type="text" class="form-control" placeholder="Veuillez renseigner votre nom et prénom" />
                <ErrorMessage name="nom" class="text-danger" />
              </div>

              <div class="col-md-6">
                <Field name="email" type="email" class="form-control" placeholder="Votre mail" required />
                <ErrorMessage name="email" class="text-danger" />
              </div>

              <div class="col-md-12">
                <Field name="objet" type="text" class="form-control" placeholder="L'objet de votre message" required />
                <ErrorMessage name="objet" class="text-danger" />
              </div>

              <div class="col-md-12">
                <Field name="message" as="textarea" class="form-control" rows="6" placeholder="Votre message" required />
                <ErrorMessage name="message" class="text-danger" />
              </div>

              <div class="col-md-12 text-center">
                <button type="submit" class="btn btn-success">Envoyer</button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { success, error } from '@/utils/utils';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'ReclamationForm',
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  setup() {
    const router = useRouter();

    const reclamationSchema = Yup.object().shape({
      nom: Yup.string().required("Le nom est obligatoire."),
      email: Yup.string().email("Email invalide").required("L'email est obligatoire."),
      objet: Yup.string().required("L'objet est obligatoire."),
      message: Yup.string().required("Le message est obligatoire."),
    });


    const submitReclamation  = async (values, {resetForm}) => {
        console.log("values");
        ApiService.post("/reclamations",values)
          .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
              resetForm();
            //  router.push({ name: "HomePage" });
            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
      };
    

    return {
      reclamationSchema,
      submitReclamation,
    };
  },
});
</script>
